import React from 'react'
import { Box, Typography, Card, CardContent, Grid } from '@mui/material'
import DocumentAccordion from './DocumentAccordion.jsx'
import { formatDate } from '../utils/documentUtils.js'

const DocumentsList = ({
  requestTask,
  documents,
  dragOverDocId,
  setDragOverDocId,
  onDragFiles,
  onDeleteFile,
  unmatchedFiles,
}) => {
  const otherDocument = {
    id: 'unmatched',
    custom_name: 'Other',
    name: 'Other / Unmatched Files',
    files: unmatchedFiles || [],
    isOther: true,
  }

  const isRequestRejected = requestTask.status === 'rejected'

  const filteredDocuments = isRequestRejected
    ? documents.filter(
        doc =>
          doc.status === 'pending_reupload' || doc.status === 'pending_upload',
      )
    : documents

  const requiredDocuments = filteredDocuments.filter(
    doc => doc.settings?.number_of_files > 0,
  )

  const allDocumentsFulfilled =
    requiredDocuments.length > 0 &&
    requiredDocuments.every(
      doc =>
        (doc.files?.length || 0) >= doc.settings.number_of_files &&
        doc.status !== 'pending_reupload',
    )

  const allDocuments = [...filteredDocuments, otherDocument]

  return (
    <>
      <Box
        sx={{
          mt: 4,
          mb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant="h3">Requested Documents</Typography>

          {allDocumentsFulfilled && (
            <Typography
              variant="subtitle1"
              sx={{ mt: 0.5 }}
            >
              All requested documents are fulfilled and ready for submission
            </Typography>
          )}
        </Box>
        {requestTask.documents_range_to_date && (
          <Typography variant="body2">
            <strong>From:</strong>{' '}
            {formatDate(requestTask.documents_range_from_date)} |{' '}
            <strong>To:</strong>{' '}
            {formatDate(requestTask.documents_range_to_date)}
          </Typography>
        )}
      </Box>
      <Card
        variant="outlined"
        sx={{ mt: 3 }}
      >
        <CardContent>
          <Grid
            container
            spacing={2}
          >
            {allDocuments.map(doc => (
              <Grid
                item
                xs={12}
                sm={6}
                key={doc.id || `custom-${doc.custom_name}`}
              >
                <DocumentAccordion
                  doc={doc}
                  dragOverDocId={dragOverDocId}
                  setDragOverDocId={setDragOverDocId}
                  onDragFiles={onDragFiles}
                  onDeleteFile={onDeleteFile}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {requestTask.special_instructions && (
        <Box
          sx={{
            mt: 1,
            p: 2,
            pl: 0,
          }}
        >
          <Typography variant="h5">
            <strong>Special Instructions</strong> :{' '}
            {requestTask.special_instructions}
          </Typography>
        </Box>
      )}
    </>
  )
}

export default DocumentsList
